import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './CommandButton.module.scss';

const cx = classNames.bind(styles);

const CommandButton = ({ Icon, text = '', pressed = false, disabled = false, ...rest }) => {
  return (
    <button type="button" className={cx(['container', { pressed, disabled }])} {...rest}>
      <Icon size={20} color="white" />
      <div className={cx('text')}>{text}</div>
    </button>
  );
};

CommandButton.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  text: PropTypes.string,
  pressed: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default React.memo(CommandButton);
